import { render, staticRenderFns } from "./VaultList.vue?vue&type=template&id=1937e8dc&"
import script from "./VaultList.vue?vue&type=script&lang=ts&"
export * from "./VaultList.vue?vue&type=script&lang=ts&"
import style0 from "./VaultList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports